const acctarget = document.querySelector(".wrapper.customer");
const sectionB = document.querySelector(
  '[id$="__17876265623e6ed00b"]'
);
acctarget.appendChild(sectionB);

document.addEventListener("DOMContentLoaded", () => {
  const tabs = document.querySelectorAll(".customer-tab li");

  const contents = [
    document.querySelector(".order-history"),
    document.querySelector(".my-coupon"),
    document.querySelector(".account-information"),
  ];

  function showTab(index) {
    tabs.forEach((tab, i) => {
      tab.classList.toggle("active", i === index);
    });

    contents.forEach((content, i) => {
      if (!content) return;
      content.style.display = i === index ? "block" : "none";
    });
  }

  // 初期表示
  showTab(0);

  // タブ切替
  tabs.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      showTab(index);
    });
  });
});